import React from 'react';
import ReactInfiniteScroll from 'react-infinite-scroller';

import { times } from 'lodash';

type ReactInfiniteScrollProps = ReactInfiniteScroll['props'];

export interface InfiniteScrollProps extends Omit<ReactInfiniteScrollProps, 'hasMore' | 'loadMore'> {
  hasNext: boolean;
  isLoadingNext: boolean;
  count?: number;
  loadNext: (count: number) => void;
  // TODO Add support for `react-window`
  // virtualized?: boolean;
}

const InfiniteScroll: React.FC<InfiniteScrollProps> = ({
  children,
  hasNext,
  isLoadingNext,
  loader,
  count = 15,
  loadNext,
  ...rest
}) => (
  <ReactInfiniteScroll
    useWindow={false}
    hasMore={hasNext}
    loadMore={() => {
      if (!isLoadingNext) {
        loadNext(count);
      }
    }}
    {...rest}
  >
    {children}
    {isLoadingNext && loader && <>{times(count / 5).map((i) => React.cloneElement(loader, { key: i }))}</>}
  </ReactInfiniteScroll>
);

export default InfiniteScroll;
